import { LAYOUT as DISCOVER_LAYOUT } from '../constants/discover';
import { LAYOUT as EXPERIENCES_LAYOUT } from '../constants/experiences';
import { REQUEST } from '../actions/action_types';
import * as DISCOVER from '../actionTypes/discover';
import * as EXPERIENCE from '../actionTypes/experiences';
import * as JOURNAL from '../actionTypes/journal';

/*
漸進移除 reducer request_state_reducer 內容過來
request_state_reducer 全部混在一起 非常亂 而且還是物件形式
先前開發將 API 狀態移進該頁 reducer 但應該都移回此 reducer

兩點注意：
  1. 按照目前 API server 分類
  2. 只能放 API 狀態 不要放參數包含 token、queryString、id 有的沒有的
  3. 若從某個頁面離開，要將該頁面打過 API 狀態都還原成 INIT 初始值避免下次進入該頁面就不打 API 了
  4. 為避免從 actionTypes/product import 太多行 code，一律 * as XXX 的方式 import 進來
 */

const initState = {
  getLayouts: REQUEST.INIT,
  getExperienceLayouts: REQUEST.INIT,
  [DISCOVER_LAYOUT.EXPERT_LIST.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.POPULAR_POI.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.POPULAR_ITINERARY.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.FEATURE_LIST.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.POPULAR_JOURNAL.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.LATEST_JOURNAL.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.PRODUCT_LIST.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.PRODUCT_BANNER.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.TOPIC.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.ACTION_BUTTONS.NAME]: REQUEST.INIT,
  [DISCOVER_LAYOUT.FUTURE_COUNT.NAME]: REQUEST.INIT,
  [EXPERIENCES_LAYOUT.E_PRODUCT_BANNER.NAME]: REQUEST.INIT,
  [EXPERIENCES_LAYOUT.E_PRODUCT_FEATURE.NAME]: REQUEST.INIT,
  [EXPERIENCES_LAYOUT.E_PRODUCT_LIST.NAME]: REQUEST.INIT,
  [EXPERIENCES_LAYOUT.E_AGENT_PRODUCT.NAME]: REQUEST.INIT,
  getJournal: REQUEST.INIT,
  getArticles: REQUEST.INIT,
  fetchMyPublishedJournals: REQUEST.INIT,
  fetchMyDraftJournals: REQUEST.INIT,
  updateJournalStatus: REQUEST.INIT,
  updateJournalCoverStatus: REQUEST.INIT,
  publishJournalStatus: REQUEST.INIT
};
const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  switch (action.type) {
    case DISCOVER.GET_LAYOUTID.LOADING:
      return {
        ...state,
        getLayouts: REQUEST.LOADING
      };
    case EXPERIENCE.GET_EXPERIENCE_ID.LOADING:
      return {
        ...state,
        getExperienceLayouts: REQUEST.LOADING
      };
    case DISCOVER.GET_ACTION_BUTTONS.LOADING:
      return {
        ...state,
        [DISCOVER_LAYOUT.ACTION_BUTTONS.NAME]: REQUEST.LOADING
      };
    case DISCOVER.GET_FUTURE_COUNT.LOADING:
      return {
        ...state,
        [DISCOVER_LAYOUT.FUTURE_COUNT.NAME]: REQUEST.LOADING
      };
    case DISCOVER.GET_EXPERT_LIST.LOADING:
    case DISCOVER.GET_POPULAR_POI.LOADING:
    case DISCOVER.GET_POPULAR_ITINERARY.LOADING:
    case DISCOVER.GET_FEATURE_LIST.LOADING:
    case DISCOVER.GET_POPULAR_JOURNAL.LOADING:
    case DISCOVER.GET_LATEST_JOURNAL.LOADING:
    case DISCOVER.GET_PRODUCT_LIST.LOADING:
    case DISCOVER.GET_PRODUCT_BANNER.LOADING:
    case DISCOVER.GET_DISCOVER_TOPIC_01.LOADING:
      return {
        ...state,
        [action.payload.key]: REQUEST.LOADING
      };

    case EXPERIENCE.GET_E_PRODUCT_BANNER.LOADING:
    case EXPERIENCE.GET_E_PRODUCT_LIST.LOADING:
    case EXPERIENCE.GET_E_PRODUCT_FEATURE.LOADING:
    case EXPERIENCE.GET_E_AGENT_PRODUCT.LOADING:
      return {
        ...state,
        [action.payload.key]: REQUEST.LOADING
      };

    case JOURNAL.FETCH_JOURNAL.LOADING:
      return {
        ...state,
        getJournal: REQUEST.LOADING
      };
    case JOURNAL.FETCH_MY_PUBLISHED_JOURNAL.LOADING:
      return {
        ...state,
        fetchMyPublishedJournals: REQUEST.LOADING
      };
    case JOURNAL.FETCH_MY_DRAFT_JOURNAL.LOADING:
      return {
        ...state,
        fetchMyDraftJournals: REQUEST.LOADING
      };
    case JOURNAL.UPDATE_JOURNAL.LOADING:
    case JOURNAL.UPDATE_JOURNAL_POIS.LOADING:
    case JOURNAL.UPDATE_POI_PHOTO.LOADING:
      return {
        ...state,
        updateJournalStatus: REQUEST.LOADING
      };
    case JOURNAL.UPDATE_JOURNAL_COVER.LOADING:
      return {
        ...state,
        updateJournalStatus: REQUEST.LOADING,
        updateJournalCoverStatus: REQUEST.LOADING
      };
    case DISCOVER.GET_LAYOUTID.SUCCESS:
      return {
        ...state,
        getLayouts: REQUEST.SUCCESS
      };
    case EXPERIENCE.GET_EXPERIENCE_ID.SUCCESS:
      return {
        ...state,
        getExperienceLayouts: REQUEST.SUCCESS
      };
    case DISCOVER.GET_ACTION_BUTTONS.SUCCESS:
      return {
        ...state,
        [DISCOVER_LAYOUT.ACTION_BUTTONS.NAME]: REQUEST.SUCCESS
      };
    case DISCOVER.GET_FUTURE_COUNT.SUCCESS:
      return {
        ...state,
        [DISCOVER_LAYOUT.FUTURE_COUNT.NAME]: REQUEST.SUCCESS
      };
    case DISCOVER.GET_EXPERT_LIST.SUCCESS:
    case DISCOVER.GET_POPULAR_POI.SUCCESS:
    case DISCOVER.GET_POPULAR_ITINERARY.SUCCESS:
    case DISCOVER.GET_FEATURE_LIST.SUCCESS:
    case DISCOVER.GET_POPULAR_JOURNAL.SUCCESS:
    case DISCOVER.GET_LATEST_JOURNAL.SUCCESS:
    case DISCOVER.GET_PRODUCT_LIST.SUCCESS:
    case DISCOVER.GET_PRODUCT_BANNER.SUCCESS:
    case DISCOVER.GET_DISCOVER_TOPIC_01.SUCCESS:
      return {
        ...state,
        [action.payload.key]: REQUEST.SUCCESS
      };

    case EXPERIENCE.GET_E_PRODUCT_BANNER.SUCCESS:
    case EXPERIENCE.GET_E_PRODUCT_LIST.SUCCESS:
    case EXPERIENCE.GET_E_PRODUCT_FEATURE.SUCCESS:
    case EXPERIENCE.GET_E_AGENT_PRODUCT.SUCCESS:
      return {
        ...state,
        [action.payload.key]: REQUEST.SUCCESS
      };

    case JOURNAL.FETCH_JOURNAL.SUCCESS:
      return {
        ...state,
        getJournal: REQUEST.SUCCESS
      };

    case JOURNAL.FETCH_MY_PUBLISHED_JOURNAL.SUCCESS:
      return {
        ...state,
        fetchMyPublishedJournals: REQUEST.SUCCESS
      };
    case JOURNAL.FETCH_MY_DRAFT_JOURNAL.SUCCESS:
      return {
        ...state,
        fetchMyDraftJournals: REQUEST.SUCCESS
      };
    case JOURNAL.UPDATE_JOURNAL.SUCCESS:
    case JOURNAL.UPDATE_JOURNAL_POIS.SUCCESS:
    case JOURNAL.UPDATE_POI_PHOTO.SUCCESS:
      return {
        ...state,
        updateJournalStatus: REQUEST.SUCCESS
      };
    case JOURNAL.UPDATE_JOURNAL_COVER.SUCCESS:
      return {
        ...state,
        updateJournalStatus: REQUEST.SUCCESS,
        updateJournalCoverStatus: REQUEST.SUCCESS
      };
    case DISCOVER.GET_LAYOUTID.FAIL:
      return {
        ...state,
        getLayouts: REQUEST.FAIL
      };
    case EXPERIENCE.GET_EXPERIENCE_ID.FAIL:
      return {
        ...state,
        getExperienceLayouts: REQUEST.FAIL
      };
    case DISCOVER.GET_ACTION_BUTTONS.FAIL:
      return {
        ...state,
        [DISCOVER_LAYOUT.ACTION_BUTTONS.NAME]: REQUEST.FAIL
      };
    case DISCOVER.GET_FUTURE_COUNT.FAIL:
      return {
        ...state,
        [DISCOVER_LAYOUT.FUTURE_COUNT.NAME]: REQUEST.FAIL
      };
    case DISCOVER.GET_EXPERT_LIST.FAIL:
    case DISCOVER.GET_POPULAR_POI.FAIL:
    case DISCOVER.GET_POPULAR_ITINERARY.FAIL:
    case DISCOVER.GET_FEATURE_LIST.FAIL:
    case DISCOVER.GET_POPULAR_JOURNAL.FAIL:
    case DISCOVER.GET_LATEST_JOURNAL.FAIL:
    case DISCOVER.GET_PRODUCT_LIST.FAIL:
    case DISCOVER.GET_PRODUCT_BANNER.FAIL:
    case DISCOVER.GET_DISCOVER_TOPIC_01.FAIL:
      return {
        ...state,
        [action.payload.key]: REQUEST.FAIL
      };

    case EXPERIENCE.GET_E_PRODUCT_BANNER.FAIL:
    case EXPERIENCE.GET_E_PRODUCT_LIST.FAIL:
    case EXPERIENCE.GET_E_PRODUCT_FEATURE.FAIL:
    case EXPERIENCE.GET_E_AGENT_PRODUCT.FAIL:
      return {
        ...state,
        [action.payload.key]: REQUEST.FAIL
      };

    case JOURNAL.FETCH_JOURNAL.FAIL:
      return {
        ...state,
        getJournal: REQUEST.FAIL
      };

    case EXPERIENCE.INIT_EXPERIENCES:
      return initState;
    case DISCOVER.INIT_DISCOVER:
      return initState;
    case JOURNAL.FETCH_MY_PUBLISHED_JOURNAL.FAIL:
      return {
        ...state,
        fetchMyPublishedJournals: REQUEST.FAIL
      };
    case JOURNAL.FETCH_MY_DRAFT_JOURNAL.FAIL:
      return {
        ...state,
        fetchMyDraftJournals: REQUEST.FAIL
      };
    case JOURNAL.UPDATE_JOURNAL.FAIL:
    case JOURNAL.UPDATE_JOURNAL_POIS.FAIL:
    case JOURNAL.UPDATE_POI_PHOTO.FAIL:
      return {
        ...state,
        updateJournalStatus: REQUEST.FAIL
      };
    case JOURNAL.UPDATE_JOURNAL_COVER.FAIL:
      return {
        ...state,
        updateJournalStatus: REQUEST.FAIL,
        updateJournalCoverStatus: REQUEST.FAIL
      };
    case JOURNAL.PUBLISH_JOURNAL.LOADING:
      return {
        ...state,
        publishJournalStatus: REQUEST.LOADING
      };
    case JOURNAL.PUBLISH_JOURNAL.SUCCESS:
      return {
        ...state,
        publishJournalStatus: REQUEST.SUCCESS
      };
    case JOURNAL.PUBLISH_JOURNAL.FAIL:
      return {
        ...state,
        publishJournalStatus: REQUEST.FAIL
      };
    case JOURNAL.RESET_EDIT_JOURNAL:
      return {
        ...state,
        updateJournalStatus: REQUEST.INIT,
        updateJournalCoverStatus: REQUEST.INIT,
        publishJournalStatus: REQUEST.INIT
      };
    default:
      return state;
  }
};
